import { render, staticRenderFns } from "./createOrUpdateContract.vue?vue&type=template&id=ea4d208c"
import script from "./createOrUpdateContract.vue?vue&type=script&lang=js"
export * from "./createOrUpdateContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports